import { forwardRef, type Ref, type SVGProps } from "react";
const IconLaptopOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M29.77 21.37A1 1 0 0 0 29 21h-1V8a3 3 0 0 0-3-3H7a3 3 0 0 0-3 3v13H3a1 1 0 0 0-.77.37 1 1 0 0 0-.23.83l.38 1.8a5 5 0 0 0 4.9 4h17.44a5 5 0 0 0 4.9-4l.38-1.8a1 1 0 0 0-.23-.83M6 8a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v13H6zm21.66 15.59A3 3 0 0 1 24.72 26H7.28a3 3 0 0 1-2.94-2.41L4.22 23h8.16l.22.44A2.81 2.81 0 0 0 15.13 25h1.74a2.81 2.81 0 0 0 2.53-1.56l.22-.44h8.16z" />
    <path d="M18 9a1 1 0 0 1-1 1h-2a1 1 0 0 1 0-2h2a1 1 0 0 1 1 1" />
  </svg>
);
const ForwardRef = forwardRef(IconLaptopOutlineSVG);
ForwardRef.displayName = "IconLaptopOutline";
export { ForwardRef as IconLaptopOutline };
